import { ROUTES, STORAGE_KEYS } from "../utils/key_helper";
import { API_URL } from '../utils/constant';
// ------------------- HEADER BUILDER -------------------
function buildHeaders({ contentType } = {}) {
    const headers = new Headers();
    const token = localStorage.getItem(STORAGE_KEYS.AVFX_ADMIN_ACCESS_TOKEN);
    if (token) headers.append("Authorization", token);
    if (contentType) headers.append("Content-Type", contentType);
    return headers;
}

// ------------------- BASE FUNCTIONS -------------------

// GET API → return full response
export async function makeGetApiRequest(path) {
    try {
        const options = {
            method: "GET",
            headers: buildHeaders({}),
        };
        const response = await fetch(`${API_URL}${path}`, options);
        const resData = await response.json();

        if (response.status === 401) {
            localStorage.removeItem(STORAGE_KEYS.AVFX_ADMIN_ACCESS_TOKEN);
            window.location.href = '/login';
        }
        if (!response.ok || resData.error) {
            return { error: resData.error?.data || resData.error || { message: "API failed" } };
        }
        return resData;  // full JSON response
    } catch (error) {
        console.error("GET API error:", error);
        return { error: { message: "Api request error", error } };
    }
}

// POST API → wrap inside { result }
export async function makeApiRequest(path, params) {
    try {
        const options = {
            method: "POST",
            body: JSON.stringify(params),
            headers: buildHeaders({ contentType: "application/json" }),
        };

        const response = await fetch(`${API_URL}${path}`, options);
        const resData = await response.json();

        if (response.status === 401) {
            localStorage.removeItem(STORAGE_KEYS.AVFX_ADMIN_ACCESS_TOKEN);
            window.location.href = '/login';
        }

        if (!response.ok || resData.error) {
            return { error: resData.error?.data || resData.error || { message: "API failed" } };
        }

        return { result: resData };
    } catch (error) {
        console.error("POST API error:", error);
        return { error: { message: "Api request error", error } };
    }
}
// ------------------- UTILITY TO HANDLE POST RESPONSE -------------------

const handlePostResponse = response => {
    if (response?.result) return response.result;
    if (response?.error) throw new Error(response.error.message);
    throw new Error("Unknown error. Please try again.");
};

// ------------------- UTILITY TO HANDLE GET RESPONSE -------------------

const handleGetResponse = response => {
    if (response?.error) throw new Error(response.error.message);
    if (response) return response;
    throw new Error("Unknown error. Please try again.");
};
// -------------------------------------- AUTH ADMIN  --------------------------------------

// V1 - ADMIN LOGIN
export const AdminLogin = async payload => handlePostResponse(await makeApiRequest("/auth/admin/login", payload))

// -------------------------------------- AUTH ADMIN  --------------------------------------
//V1 - CHANGE PASSWORD 
export const AdminChangePassword = async payload => handlePostResponse(await makeApiRequest("/admin/resetpassword", payload))

// ------------------------------------  MAIL CONFIGS  ------------------------------------
//V1 - GET MAIL CONFIGS
export const GetMailConfigs = async () => handleGetResponse(await makeGetApiRequest("/admin/mailmanager/getmailconfigs"))

// V1 - UPDATE MAIL CONFIGS
export const UpdateMailConfigs = async payload => handlePostResponse(await makeApiRequest("/admin/mailmanager/updatemailconfig", payload))

//V1 - GET MAIL TEMPLATE
export const GetMailTemplate = async () => handleGetResponse(await makeGetApiRequest("/admin/mailmanager/getmailtemplates"))

// V1 - UPDATE MAIL TEMPLATE
export const UpdateMailTemplate = async payload => handlePostResponse(await makeApiRequest("/admin/mailmanager/updatemailtemplates", payload))


// ------------------------------------USER MANAGEMENT  ------------------------------------
// V1 - GET ALL USERS
export const GetAllUsers = async payload => handlePostResponse(await makeApiRequest("/admin/usermanager/getallusers", payload))

// V1 - GET USER BY ID
export const GetUserById = async payload => handlePostResponse(await makeApiRequest("/admin/usermanager/getuserbyid", payload))

// V1 - GET USER STRATEGY CHILD
export const GetUserStrategyChild = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getuserstrategychild", payload))

// V1 - GET USER MASTER STRATEGY
export const GetUserMasterStrategy = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getusermasterstrategy", payload))

// V1 - SEND BULK MAILS
export const SendBulkMails = async payload => handlePostResponse(await makeApiRequest("/admin/communication/sendbulkmails", payload))

// ------------------------------------STRATEGY MANAGEMENT  ------------------------------------
// V1 -  GET MASTER STRATEGY
export const GetMasterStrategy = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getmasterstrategies", payload))

// V1 -  GET MASTER STRATEGY BY ID 
export const GetMasterStrategyInfo = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getmasterstrategyinfo", payload))

// V1 -  GET MASTER STRATEGY COPIERS
export const GetMasterStrategyCopiers = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getstrategycopiers", payload))

// V1 -  GET MASTER STRATEGY LEDGER
export const GetMasterStrategyLedger = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getstrategymasterledger", payload))

// V1 -  GET STRATEGY CHILD INFo
export const GetStrategyCopierInfo = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getstrategychildinfo", payload))

// V1 -  GET MASTER STRATEGY COPIER LEDGER
export const GetCopierLedger = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/getstrategycopierledger", payload))

// V1 - UPDATE STRATEGY PUBLIC VIEW STATUS
export const UpdateStrategyPublicViewStatus = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/enablemasterpublicview", payload))
// V1 - UPDATE STRATEGY ALLOW COPY STATUS
export const UpdateStrategyAllowCopyStatus = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/updatemasterallowcopy", payload))
// V1 - UPDATE STRATEGY VALID STATUS 
export const UpdateStrategyValidStatus = async payload => handlePostResponse(await makeApiRequest("/admin/strategymanager/updatemastervalidate", payload))

// ---------------------------------------------ACCOUNT MANAGER---------------------------------------------
// V1 -  GET ACCOUNT INFO
export const GetAccountInfo = async payload => handlePostResponse(await makeApiRequest("/admin/accountmanager/getaccountinfo", payload))

// V1 -  GET PENDING ORDERS 
export const GetPendingOrders = async payload => handlePostResponse(await makeApiRequest("/admin/accountmanager/getpendingorders", payload))

// V1 -  GET OPEN POSITIONS
export const GetOpenPositions = async payload => handlePostResponse(await makeApiRequest("/admin/accountmanager/getopenpositions", payload))


// V1 -  GET CLOSE ORDERS
export const GetCloseOrders = async payload => handlePostResponse(await makeApiRequest("/admin/accountmanager/gethistoricaldeals", payload))


// ---------------------------------------------DASHBOARD-------------------------------------------
//V1 - GET DASHBOARD STATES 
export const GetDashboardStates = async () => handleGetResponse(await makeGetApiRequest("/admin/getdashboardstats"))

// V1 -  GET REGISTERED USERS
export const GetRegisteredUsers = async payload => handlePostResponse(await makeApiRequest("/admin/getregisteredusers", payload))

// V1 - GET MASTER STARTEGIES GRAPH
export const GetMasterStrategiesGraph = async payload => handlePostResponse(await makeApiRequest("/admin/getmasterstrategiesgraph", payload))

// V1 - GET STRATGEY COPIER GRAPH
export const GetStrategyCopierGraph = async payload => handlePostResponse(await makeApiRequest("/admin/getstrategycopiersgraph", payload))

// V1 - GET CHILD ORDERS GRAPH 
export const GetChildOrdersGraph = async payload => handlePostResponse(await makeApiRequest("/admin/getchildordersgraph", payload))

// V1 - GET TOP 10 MASTERS 
export const GetTop10Masters = async payload => handlePostResponse(await makeApiRequest("/admin/gettopmasters", payload))

// V1 - UPDATE MASTER MINIMUM BALANCE
export const UpdateMasterMinBalance = async payload => handlePostResponse(await makeApiRequest("/admin/updatemasterminbalance", payload))

// V1 - UPDATE MASTER PLATFOMR FEES
export const UpdateMasterPlatformFees = async payload => handlePostResponse(await makeApiRequest("/admin/updatemasterplatformfees", payload))

